module.exports = __webpack_public_path__ + "static/DishonorCoverSliderImage-baede43fc03b9a61309af35b8e491d54.jpeg";